export default __webpack_public_path__ + "static/media/liquid-loading.cf229b23.gif";